import React from 'react';
import clsx from 'clsx';
import PublicContainer from './PublicContainer.jsx';

function resolveLinkClick(event, href, onClick, onNavigate) {
  if (onClick) {
    event.preventDefault();
    onClick(event);
    return;
  }

  if (onNavigate && typeof href === 'string' && href.length > 0) {
    event.preventDefault();
    onNavigate(href);
  }
}

const PublicFooter = ({
  brandName,
  brandLogo,
  brandDescription,
  sections = [],
  legalLinks = [],
  copyright,
  socialContent,
  className,
  onNavigate,
  id,
  ...props
}) => {
  return (
    <footer id={id} className={clsx('mt-16 bg-[var(--primary,#1D4ED8)] text-[var(--primary-foreground,#FFFFFF)]', className)} {...props}>
      <PublicContainer className="py-12">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            {brandLogo?.element ? brandLogo.element : null}

            {!brandLogo?.element && brandLogo?.src ? (
              <img
                src={brandLogo.src}
                alt={brandLogo.alt || `${brandName || 'Brand'} logo`}
                className="h-12 w-auto max-w-full object-contain"
                loading="lazy"
              />
            ) : null}
            {brandDescription ? (
              <p className={clsx('font-body text-[15px] leading-relaxed text-[var(--primary-foreground,#FFFFFF)]', brandLogo?.src ? 'mt-3' : 'mt-4')}>
                {brandDescription}
              </p>
            ) : null}
            {socialContent ? (
              <div className="mt-5">
                {socialContent}
              </div>
            ) : null}
          </div>

          {sections.map((section) => (
            <nav key={section.title} className="space-y-3" aria-label={section.title}>
              <h3 className="font-display text-[16px] font-semibold text-[var(--primary-foreground,#FFFFFF)]">{section.title}</h3>
              <div className="space-y-2">
                {(section.links || []).map((link) => (
                  <a
                    key={`${section.title}-${link.label}`}
                    href={link.href || '#'}
                    className="block font-body text-[14px] text-[var(--primary-foreground,#FFFFFF)] transition-colors hover:text-[var(--primary-soft,#DBEAFE)]"
                    onClick={(event) => resolveLinkClick(event, link.href, link.onClick, onNavigate)}
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </nav>
          ))}
        </div>

        <div className="mt-10 border-t border-white/20 pt-8">
          <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-center">
            <p className="font-body text-[14px] text-[var(--primary-foreground,#FFFFFF)]">{copyright}</p>
            <div className="flex flex-wrap items-center gap-5">
              {legalLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href || '#'}
                  className="font-body text-[14px] text-[var(--primary-foreground,#FFFFFF)] transition-colors hover:text-[var(--primary-soft,#DBEAFE)]"
                  onClick={(event) => resolveLinkClick(event, link.href, link.onClick, onNavigate)}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </PublicContainer>
    </footer>
  );
};

export default PublicFooter;
